/* eslint-disable react/jsx-no-target-blank */
import { useEffect, useState } from "react";
import PortfolioList from "../portfolioList/PortfolioList";
import "./portfolio.scss";
import "./text.css"
import {
  featuredPortfolio,
   webPortfolio,
   mobilePortfolio,
   designPortfolio,
   contentPortfolio,
} from "../../data";
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import {
  GitHub,
  BubbleChart,
  LinkedIn,
  Book,

} from "@material-ui/icons";

export default function Portfolio() {
  const [selected, setSelected] = useState("featured");
  const [data, setData] = useState([]);
  const classes = makeStyles();

  const list = [
    {
      id: "featured",
      title: "Java(Spring)",
    },
    {
      id: "web",
      title: "C#(.NET)",
    },
    {
      id: "mobile",
      title: "Other Projects",
    },
    {
      id: "content",
      title: "Content",
    },
  ];

  useEffect(() => {
    switch (selected) {
      case "featured":
        setData(featuredPortfolio);
        break;
      case "web":
        setData(webPortfolio);
        break;
      case "design":
        setData(designPortfolio);
        break;
        case "mobile":
        setData(mobilePortfolio);
        break;
      case "content":
        setData(contentPortfolio);
        break;
      default:
        setData(featuredPortfolio);
    }
  }, [selected]);

  const useStyles = makeStyles({
    root: {
      maxWidth: 345,
    },
  });
  return (
    <div className="portfolio" id="portfolio"> <br/>
      {/* <h1 className="port">Portfolio</h1> */}
      <ul>
        {list.map((item) => (
          <PortfolioList
            title={item.title}
            active={selected === item.id}
            setSelected={setSelected}
            id={item.id}
          />
        ))}
      </ul>
      <div className="container">
        {data.map((d) => (
          <div className="item">
            
            <img src={d.img} alt="img" />
            <h3>{d.title}</h3>
          </div>
        ))}
      </div>
      <br />
      <Card className={classes.root}>
        <CardActionArea>
          <CardMedia
            component="img"
            alt="Contemplative Reptile"
            width="150"
            height="130"
            src="https://res.cloudinary.com/mycloudimageyea/image/upload/v1642675195/971_ej0xlc.jpg"
            title="Contemplative Reptile"
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              All My Projects
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              <h4>
              You can access my content from the links below.
              </h4>
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <GitHub className="icon" style={{ marginLeft: "10px" }} />
            <span>
              <a
                href="https://github.com/yusufenesaras"
                style={{ textDecoration: "none" }}
                target="_blank"
              >
                Github
              </a>
            </span>
            <BubbleChart className="icon" style={{ marginLeft: "10px" }} />
            <span>
              <a
                href="https://y-enesaras.medium.com/"
                style={{ textDecoration: "none" }}
                target="_blank"
              >
                Medium
              </a>
            </span>
            <LinkedIn className="icon" style={{ marginLeft: "10px" }} />
            <span>
              <a
                href="https://www.linkedin.com/in/yusufenesaras/"
                style={{ textDecoration: "none" }}
                target="_blank"
              >
                LinkedIn
              </a>
            </span>

        </CardActions>
        
      </Card>
      
    </div>
  );
}
